'use es6'; // Adapted from http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
// generates 4-digit hex number

function getHex4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

export function generateGuid() {
  const double = `${getHex4()}${getHex4()}`;
  const singles = `${getHex4()}-${getHex4()}-${getHex4()}`;
  const triple = `${getHex4()}${getHex4()}${getHex4()}`;
  return `${double}-${singles}-${triple}`;
}